import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import ReactTooltip from 'react-tooltip';
import { scrollToHash } from 'helpers/urlTools';
import UnsavedChangesModal from 'components/UnsavedChangesModal';
import App from 'modules/App';
import messages from '../../messages';
import Sidebar from './Sidebar';
import styles from './DashboardLayout.pcss';
const DashboardLayout = ({ metaTitleMessage, metaDescriptionMessage, children })=>{
    const route = useSelector(App.selectors.route);
    const isClientInitialized = useSelector(App.selectors.isClientInitialized);
    const mainContentRef = useRef(null);
    useEffect(()=>{
        if (isClientInitialized) {
            scrollToHash(route, 0, 0, mainContentRef.current);
        }
    }, [
        isClientInitialized
    ]);
    useStyles(styles);
    if (!isClientInitialized) return null;
    const titleMessage = metaTitleMessage || messages.meta.title;
    const descriptionMessage = metaDescriptionMessage || messages.meta.description;
    const onSetMainContentRef = (el)=>{
        mainContentRef.current = el;
    };
    return /*#__PURE__*/ _jsx(App.components.LanguageProvider, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.root, 'no-gutters'),
            children: [
                /*#__PURE__*/ _jsx(App.components.IntlHelmet, {
                    titleMessage: titleMessage,
                    descriptionMessage: descriptionMessage
                }),
                /*#__PURE__*/ _jsx(Sidebar, {}),
                /*#__PURE__*/ _jsxs("div", {
                    id: "mainContent",
                    className: styles.content,
                    ref: onSetMainContentRef,
                    children: [
                        /*#__PURE__*/ _jsx(App.components.AlertsBus, {
                            className: "mb-5",
                            isGlobal: true
                        }),
                        children
                    ]
                }),
                /*#__PURE__*/ _jsx(UnsavedChangesModal, {}),
                /*#__PURE__*/ _jsx(ReactTooltip, {
                    id: "globalTooltip",
                    place: "right"
                })
            ]
        })
    });
};
export default DashboardLayout;
